module.exports = __webpack_public_path__ + "img/logo.e0af8d9e.png";